import type React from 'react';
import { cn } from '@/lib/utils';

export type PageWidth = 'narrow' | 'standard' | 'wide' | 'full';

export interface WidthProps {
    width?: PageWidth;
}

// eslint-disable-next-line react-refresh/only-export-components
export const widthClasses: Record<PageWidth, string> = {
    narrow: "max-w-3xl",    // Formulaires (Login, Create, Edit)
    standard: "max-w-5xl",  // Dashboards (RaceDetails)
    wide: "max-w-7xl",      // Grilles (Home)
    full: "w-full",         // Maps ou Custom
};

type PageProps = React.HTMLAttributes<HTMLDivElement>;

export function Page({ children, className, ...props }: PageProps) {
    return (
        <div className={cn("min-h-screen bg-white pb-safe", className)} {...props}>
            {children}
        </div>
    );
}
